<template>
	<div class="info">
		<div class="layout">

			<div v-if="hasExpiredSubscription" class="expiring-alert expired">
				⚠️ Il tuo abbonamento è scaduto! Contattaci per rinnovarlo.
			</div>
			<div v-else-if="hasExpiringSubscription" class="expiring-alert">
				⚠️ Il tuo abbonamento sta per scadere! Contattaci per rinnovarlo.
			</div>

			<div class="profile-card">
				<div class="container">
					<div class="image pad-l">
						<img :src="user.picture_url"/>

						<svg class="foreground" viewBox="0 0 160 160" width="100%" height="100%" fill="transparent">
							<circle
								r="52" cx="80" cy="80"
								stroke-dasharray="314"/>
						</svg>
						<svg class="background" viewBox="0 0 160 160" width="100%" height="100%" fill="transparent">
							<circle
								r="58" cx="80" cy="80"
								stroke-dasharray="314"/>
						</svg>
					</div>

					<div class="pad-l">
						<div class="name">{{ user.first_name + ' ' + user.last_name }}</div>
						<div class="email">
							<span class="icon-md t-middle">email</span>
							<span class="d-inlineblock w-xs"></span>
							<span class="t-middle">{{ user.email }}</span>
						</div>
						<!--<div v-if="user.membership"><b>Eximus Online Training: ON</b></div>-->
						<br>
						<a href="../first-access" style="color: #ffe010;">Cambia Password</a>
					</div>
				</div>
			</div>
		<!--<div class="prom_cont" id="once">
				<div class="prom">
					<h2>Avviso per tutti i nostri atleti!  &#127947;</h2>
					<p><b>A partire da Lunedì 5 Febbraio le classi di Lunedì e Giovedì delle 18.15 verranno anticipate alle 18.00</b></p>
					<div class="button" @click="chiudi()"><button>X</button></div>
				</div>
			</div>
		<div class="profile-card">
				<div class="container">
					<div class="links">
						<ul>
							<li><img :src="require('@/assets/gdrive.svg')"/><a href="https://drive.google.com/open?id=1nqXqlDgWACKEjNcMFCFBYD637o9edVzq" target="_blank">Libreria Video</a></li>
							<li><a href="#">Blog (in arrivo!)</a></li>
						</ul>
						<iframe src="https://drive.google.com/embeddedfolderview?id=18zxQp7TsHzn6p4gK9I_5B0e7EsYPtOn9#grid" width="100%" height="500" frameborder="0">
						</iframe>
					</div>

								<div class="library" v-if="user.membership">
									<div v-for="videoid in videos" :key="videoid"
										class="video">
										<div class="frame">
											<iframe class="player" :src="'http://www.youtube.com/embed/' + videoid" frameborder="0"></iframe>
										</div>
									</div>
								</div>

					<router-link v-if="user.membership" class="online-gym" :to="{name: 'eximus-online-training'}">Accedi ai tuoi allenamenti online</router-link>
				</div>
			</div>

			<div class="profile-card">
				<div class="container">
					<div class="links2">
						<ul>
							<li style="font-size:1.4em;"><img :src="require('@/assets/sanvalentino2.jpg')"/><br><b>Porta il tuo partner o un amico/a non iscritto e vi allenate gratis tutta la settimana!</b><br>(Offerta valida dal 13 al 19 Febbraio).</li>
						</ul>
					</div>
				</div>
			</div>-->
			
			<div class="profile-card">
				<div class="container">
					<div class="links2">
						<ul>
							<li style="font-size:1.4em;"><b>Chi porta un amico trova un tesoro! &#128107;</b><br>Porta un amico a provare e al momento dell'iscrizione riceverai 2 lezioni in omaggio! &#128170;</li>
						</ul>
					</div>
				</div>
			</div>
			<!--<div class="profile-card">
				<div class="container">
					<div class="links2">
						<ul>
							<li style="font-size:1.4em;"><b>Nuove Classi!</b><br>Troverai nuove classi nel calendario: lunedì, martedì e giovedì alle 12.30, martedì e venerdì alle 18.00, sabato alle 10.00.</li>
						</ul>
					</div>
				</div>
			</div>-->
			<div class="profile-card">
				<div class="container">
					<div class="links2">
						<div class="resub">
							<a href="./shop#class"><button class="buttonresub">Rinnova qui il tuo pacchetto online!</button></a>
						</div>
					</div>
				</div>
			</div>

			<div class="products" v-if="products && products.length">
				<h2>Pacchetti attivi</h2>
				
				<div class="products-grid">
					<div v-for="prod in products" :key="prod.id" 
						class="product" 
						:class="productClasses(prod)">

						<div class="info">
							<div class="name">
								<div>{{ prod.name }}</div>
								<div v-if="prod.size === 0 && isExpired(prod.expire_date)" class="badge badge-expired">Scaduto</div>
								<div v-else-if="prod.size === 0 && isExpiring(prod.expire_date)" class="badge">In Scadenza</div>
    						</div>

							<div class="charges">
								<div v-if="prod.size > 0" class="remaining">{{ prod.remaining || '-' }}</div>
								<div v-if="prod.size > 0" class="size">/{{ prod.size }}</div>
								<div v-if="prod.size === 0 && prod.expire_date" class="expiration">
									Scade il {{ formatDate(prod.expire_date) }}
								</div>
							</div>

						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ShowMore from '@/components/global/ShowMore'

export default {
	name: 'info',
	beforeMount() {
        window.addEventListener("load", this.onWindowLoad);
    },

	components: {
		ShowMore
	},

	props: {
		/// User data
		user: {
			type: Object,
			required: true
		},

		/// User products
		products: {
			type: Array,
			default: () => []
		},

		/// Videos
		videos: {
			type: Array,
			required: false
		}
	},

	computed: {
		/**
		 * Active subscription
		 */
		sub() {

			return this.user.subscriptions[0]
		},

		hasExpiringSubscription() {
			if (!this.products) return false;
			return this.products.some(prod => prod.size === 0 && this.isExpiring(prod.expire_date));
		},

		hasExpiredSubscription() {
			if (!this.products) return false;
			return this.products.some(prod =>
				prod.size === 0 && this.isExpired(prod.expire_date)
			);
		}
	},

	methods: {

		formatDate(dateStr) {
			if (!dateStr) return '';
			const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
			return new Date(dateStr).toLocaleDateString('it-IT', options);
		},

		productClasses(prod) {
			if (prod.size === 0) {
				// È un abbonamento
				const isExpired = this.isExpired(prod.expire_date)
				return {
					subscription: true,
					expiring: this.isExpiring(prod.expire_date),
					expiredSub: isExpired
				};
			} else {
				// È un pacchetto normale
				return {
					expired: prod.remaining <= 0
				};
			}
		},
		
		isExpiring(expirationDate) {
			if (!expirationDate) return false;
			const today = new Date();
			const expDate = new Date(expirationDate);
			const diffTime = expDate - today;
			const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
			return diffDays <= 7;
		},

		isExpired(expirationDate) {
			if (!expirationDate) return false;
			const today = new Date().setHours(0, 0, 0, 0);
			const exp = new Date(expirationDate).setHours(0, 0, 0, 0);
			return exp <= today;
		},

		onWindowLoad(){
			var testo = document.getElementById("once");
			const promotion = window.localStorage.getItem("hide_promotion2");

			if(promotion === "b"){
				testo.style.display = "none";
			}else {
				testo.style.display = "block";
				window.localStorage.setItem("hide_promotion2", "b");
			}
		},

		chiudi(){
			var prom = document.getElementById("once");
			prom.style.display = "none";
		}
	}
}
</script>

<style lang="stylus" scoped>
.info2
	padding 1em 1.5em

	background repeating-linear-gradient(45deg, rgba(dark, 0), rgba(dark, 0) 1.6em, rgba(dark, 0.5) 1.6em, rgba(dark, 0.5) 3.2em)

	font-family fontSans

.info .layout
	max-width 1280px
	margin 0 auto

	display grid
	grid-template-columns auto
	grid-gap 1em

.links
	ul
		list-style-type none
		
		li
			display flex
			align-items center

			margin 1em auto
			border-radius: 2em
			transition 0.15s ease

			img
				width 2em
				height 2em
				display block

				background light
				border-radius 30px
				padding 0.4em

				transition transform 0.25s ease

				.promosan
					width 100%
					height 3em
		
			a
				font-size 1.4em
				text-decoration none
				color #dcdcdc
				cursor pointer
				padding 0.25em
				border-radius 5px
				margin-left 0.2em
				margin-right 0.2em
				transition 0.15s ease

			&:hover

				img
					transform: rotate(120deg)
				a

.links2
	ul
		list-style-type none
		
		li
			align-items center

			margin 1em auto
			border-radius: 2em
			transition 0.15s ease

			img
				height 4em
				display block
				padding 0.4em

			a
				font-size 1.4em
				text-decoration none
				color #dcdcdc
				cursor pointer
				padding 0.25em

.profile-card
	padding 1em
	border-radius 1em

	background-color dark

	.container
		.library
			display grid
			grid-template-columns repeat(3, 1fr)
			grid-gap 1em

			padding 2em

			.video
				width 100%

				.frame
					width 100%

					position relative
					
					padding-bottom 56.25%

					.player
						width 100%
						height 100%

						position absolute
						z-index 1
		
		.online-gym

			display block

			margin 1em
			padding 0.8em
			border-radius 0.8em
			box-sizing border-box

			background-color secondary
			color light

			font-size 1.2em
			font-weight bold
			text-align center
			text-decoration none

			&:hover
				color lighter

@keyframes spin-foreground
	0%
		transform rotate(66deg)
		stroke-dashoffset 150%
	40%
		transform rotate(359deg)
		stroke-dashoffset 120%
	65%
		transform rotate(-66deg)
		stroke-dashoffset 160%
	100%
		transform rotate(66deg)
		stroke-dashoffset 150%

@keyframes spin-background
	0%
		transform rotate(52deg)
		stroke-dashoffset 150%
	40%
		transform rotate(300deg)
		stroke-dashoffset 50%
	65%
		transform rotate(20deg)
		stroke-dashoffset 160%
	100%
		transform rotate(52deg)
		stroke-dashoffset 150%

.container
	.image
		width 256px
		height 256px

		box-sizing border-box

		position relative

		&>img
			height 100%
			width 100%

			position absolute
			top 0
			left 0
			z-index 3

			padding 2em
			border-radius 50%
			box-sizing border-box
		
		&>svg
			width 100%
			height 100%

			position absolute
			top 0
			left 0

			stroke-width 2.2em

			&.foreground
				z-index 2

				stroke primary
				stroke-dashoffset 150%

				transform rotate(66deg)

				animation spin-foreground 4s ease-in-out 0.1s 2 alternate

			&.background
				z-index 1

				stroke secondary
				stroke-dashoffset 150%

				transform rotate(52deg)

				animation spin-background 4.2s ease-in-out 0s 2 alternate

	.name
		margin 0.2em 0

		color lighter

		font-size 3em
		font-weight bold

	.email
		margin 0.2em 0

		font-size 1.4em

.subscription
	margin-top 1em
	padding 2em

	.grid
		display grid
		grid-template-columns repeat(2, 1fr)
		grid-gap 1em

		@media (max-width: unit(media-phone-max, px))
			grid-template-columns 1fr
		
		.field
			.value
				padding 0.4em 0.6em
				border-bottom 1px solid primary

				color lightish

				font-size 1.2em
				font-weight bold
			
			>label
				padding 0.2em

				color primary

				font-size 0.9em

.products
	padding 2em
	border-radius 1em

	background-color dark

	.products-grid
		display grid
		grid-template-columns repeat(3, 1fr)
		grid-gap 1em

		@media screen and (max-width: unit(media-phone-max, px))
			grid-template-columns auto

		.product
			padding 1em
			border 1px solid darkish
			border-radius 0.5em

			.info
				display grid
				grid-template-columns 1fr auto
				align-items center

				.name
					color light
					margin-right 0.5em
					font-size 1.4em
					font-weight bold
				
				.charges
					padding 1em
					border-left 2px solid secondary
					text-align center
					min-height 60px
					display flex
					flex-direction column
					justify-content center
					align-items center

					.remaining
						color secondary

						font-size 2em
						font-weight bold

					.expiration
						margin-top 0.5em
						font-size 0.9em
						color lightish
			
			&.selected
				box-shadow 0 0 0 2px primary

				.name
					color primary
			
		.expired
			border-color crimson
			
			color mix(light, dark, 50%)

			.info
				.name
					color inherit
				
				.charges
					border-left-color crimson

					.remaining
						color crimson

		.expiredSub
			border 2px solid crimson
			color mix(light, dark, 50%)

			.info
				.name
					color inherit

				.charges
					border-left 2px solid crimson

.prom_cont
	z-index 9999
	position fixed
	bottom 0
	width 100%
	left 0
	display none

	.prom
		background #232b34
		font-size 1.2em
		padding 15px
		margin-left 2em
		margin-right 2em
		margin-bottom 1em
		border-radius 1em

		.button
			width 45px
			margin 0 auto

			button
				background #ffe010
				border 0px
				padding 1em
				font-size 0.8em
				border-radius 2em
				width 45px
		h2 
			color #ffe010

.resub
	max-width 100%
	padding 1em

.buttonresub
	max-width 600px

	padding 0.4em
	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.3em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.product.subscription
	border 2px solid #00bcd4 // bordo azzurro chiaro
	color light
	.name
		color light
	.charges
		border-left 2px solid #00bcd4

.product.expiring
	border 2px dashed #ffe010
	color light
	.name
		color orange
	.charges
		border-left 2px dashed #ffe010

.expiring-alert
	background-color #ff9800
	color dark
	font-weight bold
	text-align center
	padding 1em
	margin-bottom 1em
	border-radius 1em

.expiring-alert.expired
	background-color crimson
	color light

.badge
	background-color #ffe010
	color dark
	padding 0.2em 0.5em
	margin-top 0.5em
	border-radius 0.5em
	font-size 0.8em
	font-weight bold
	text-align center
	display inline-block

.package-ended
	margin-top 0.5em
	color crimson
	font-weight bold
	font-size 0.9em

.badge-expired
	background-color crimson
	color light
	padding 0.2em 0.5em
	margin-top 0.5em
	border-radius 0.5em
	font-size 0.8em
	font-weight bold
	text-align center
	display inline-block

</style>
